/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weekday: NonNullable<unknown>, day: NonNullable<unknown> }} Today_DateInputs */

const en_us2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

const pt_br2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

const es_419_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

const pt_pt2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

const fr_fr2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.day}`)
};

const de_de2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

const it_it2_today_date = /** @type {(inputs: Today_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday}, ${i?.day}`)
};

/**
* | output |
* | --- |
* | "{weekday}, {day}" |
*
* @param {Today_DateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_date = /** @type {((inputs: Today_DateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_DateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_date(inputs)
	if (locale === "es-419") return es_419_today_date(inputs)
	if (locale === "pt-PT") return pt_pt2_today_date(inputs)
	if (locale === "fr-FR") return fr_fr2_today_date(inputs)
	if (locale === "de-DE") return de_de2_today_date(inputs)
	if (locale === "it-IT") return it_it2_today_date(inputs)
	return en_us2_today_date(inputs)
});
export { today_date as "today.date" }